import Gallery from "../../Components/Gallery/Gallery";
import PageBanner from "../../layout/Banner";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { Helmet } from "react-helmet-async";

// Changed "gallerypage" to "GalleryPage"
const GalleryPage = () => {
    return (
        <>
<Helmet>
  <title>SKS Law Groups & Associates Gallery | Legal Excellence</title>

  <meta
    name="description"
    content="Explore the SKS Law Groups & Associates gallery showcasing legal events, client engagements, court proceedings, and professional achievements."
  />
  
      <link rel="canonical" href="https://skslawgroupsandassociates.com/gallery" />


  <meta
    name="keywords"
    content="SKS Law Groups Gallery, Legal Events, Court Proceedings, Law Firm Gallery, Legal Excellence, Professional Achievements, Client Engagements, Advocate Gallery, SKS Law Groups & Associates"
  />

  <meta
    property="og:title"
    content="SKS Law Groups & Associates Gallery | Legal Excellence"
  />

  <meta
    property="og:description"
    content="Explore the SKS Law Groups & Associates gallery showcasing legal events, client engagements, court proceedings, and professional achievements."
  />

  <meta property="og:type" content="website" />

  <meta
    name="twitter:title"
    content="SKS Law Groups & Associates Gallery | Legal Excellence"
  />

  <meta
    name="twitter:description"
    content="Explore the SKS Law Groups & Associates gallery showcasing legal events, client engagements, court proceedings, and professional achievements."
  />
</Helmet>
            <Header/>
            <PageBanner title={"Gallery"} subtitle={""}/>
            <Gallery/>
            <Footer/>
        </>
    )
}

export default GalleryPage;